import { render } from "./GridParteneri.vue?vue&type=template&id=1034b759&scoped=true&ts=true"
import script from "./GridParteneri.vue?vue&type=script&lang=ts"
export * from "./GridParteneri.vue?vue&type=script&lang=ts"

import "./GridParteneri.vue?vue&type=style&index=0&id=1034b759&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1034b759"]])

export default __exports__